<template>
    <div class="chart" v-if="this.$route.query['internal-view'] == 'true'">
        <div class="tags">
            <span v-if="infos.details!=undefined" class="tag is-light" v-bind:class="{'is-link': infos.details=='API-generated'}" >{{infos.details}}</span>
            <span v-if="infos.creator!=undefined" class="tag is-dark">{{infos.creator}}</span>
        </div>
        <div class="value" v-if="infos.creationtime != '-'" v-bind:style="styleObject">
        </div>
        <p class="time" v-if="infos.creationtime != '-'">{{formattedTime}}</p>
        <p class="time" v-if="infos.creationtime == '-'">Webgrafik</p>
    </div>
</template>

<script>
export default {
    name: "Pie",
    props: {
        infos: Object
    },
    computed: {
        formattedTime: function(){
            let hours = Math.floor(this.infos.creationtime / 60);
            let minutes = this.infos.creationtime % 60;

            if(hours > 0){
                return "ca. "+hours+":"+minutes;
            }else{
                return "ca. "+minutes+" Min.";
            }
        },
        styleObject: function(){
            let color = "#333";
            if(this.infos.creationtime < 10){
                color = "#008a70";
            }else if(this.infos.creationtime < 20){
                color = "#73bb5b";
            }else if(this.infos.creationtime < 30){
                color = "#c6e1aa";
            }else if(this.infos.creationtime < 45){
                color = "#febb27";
            }else if(this.infos.creationtime < 60){
                color = "#f99d22";
            }else{
                color = "#e52f4a";
            }

            return {
                "background": color,
                "background-image": "conic-gradient("+color+" "+(this.infos.creationtime*6)+"deg, #FFF 0)"
            }
        }
    }
};


function getHour(value) {
    if (value == null) { return ""; }
    if (value <= 0) { return ""; }
    var hours = Math.floor(value / 60);
    var minutes = value % 60;
    var hour = (hours > 1) ? hours + " hrs " : hours + " hr ";
    var min = (minutes > 0) ? minutes + " mins" : "";
    return hour + min;
}
</script>

<style>
.chart{
    align-items: center;
    display: flex;
    float: right;
    margin: 0 0 20px 0;
    position: relative
}

.chart .value{
    border: 1px solid #AAA;
    border-radius: 1000px;
    height: 20px;
    margin-left: 10px;
    width: 20px;
}

.chart p.time{
    font-weight: 600;
    margin-left: 8px; 
    margin-right: 10px;
    margin-bottom: 0 !important;
}

.chart .tags, .chart .tag{
    margin-bottom: 0 !important;
}

@media (max-width: 786px){
    .chart{
        align-items: baseline;
        flex-flow: column;
    }

    .chart .tags{order: 3;}
    .chart .value{order: 1;margin-left: 0 !important;}
    .chart .time{order:2;margin-left:0 !important;}

    .info-row .chart{
        margin-top: 20px;
    }

    .chart .tags{
        margin-top: 10px;
        margin-bottom: 15px !important;
    }

    .chart .tag.is-light{
        display: flex;
        max-width: 80%;
        justify-content: left;
        overflow: hidden
    }
}
</style>